(function () {
  'use strict';

  var FREE_SHIPPING_THRESHOLD = 100000; // 1000 kr i øre

  // ── Helpers ──────────────────────────────────────────
  function formatMoney(cents) {
    var fmt = (window.PXUTheme && window.PXUTheme.currency && window.PXUTheme.currency.money_format)
      ? window.PXUTheme.currency.money_format
      : '{{amount}} kr';
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return fmt.replace('{{amount}}', amount)
              .replace('{{amount_no_decimals}}', Math.round(cents / 100))
              .replace('{{amount_with_comma_separator}}', amount);
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }

  // ── DOM refs ──────────────────────────────────────────
  var drawer      = document.getElementById('cart-drawer');
  var overlay     = document.getElementById('cart-drawer-overlay');
  var itemsEl     = qs('.cd-items');
  var emptyEl     = qs('.cd-empty');
  var footerEl    = qs('.cd-footer');
  var shippingEl  = qs('.cd-shipping');
  var loadingEl   = qs('.cd-loading');
  var subtotalEl  = qs('.cd-subtotal__price');
  var countEl     = qs('.cd-header__count');

  if (!drawer) return;

  // ── Open / Close ──────────────────────────────────────
  function openDrawer()  {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.classList.add('cd-open');
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.classList.remove('cd-open');
  }
  function showLoading() { loadingEl && loadingEl.classList.add('is-active'); }
  function hideLoading() { loadingEl && loadingEl.classList.remove('is-active'); }

  // ── Fetch ─────────────────────────────────────────────
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  // ── Render ────────────────────────────────────────────
  function renderCart(cart) {
    updateHeaderCounts(cart.item_count);

    // item count
    if (countEl) {
      countEl.textContent = cart.item_count === 1
        ? '1 produkt'
        : cart.item_count + ' produkter';
    }

    // free shipping bar
    if (shippingEl) {
      var remaining = FREE_SHIPPING_THRESHOLD - cart.total_price;
      var pct = Math.min(100, Math.round((cart.total_price / FREE_SHIPPING_THRESHOLD) * 100));
      var fillEl = qs('.cd-shipping__fill', shippingEl);
      var textEl = qs('.cd-shipping__text', shippingEl);
      if (remaining > 0) {
        shippingEl.style.display = 'block';
        if (textEl) textEl.innerHTML = 'Du mangler <strong>' + formatMoney(remaining) + '</strong> for gratis frakt.';
        if (fillEl) fillEl.style.width = pct + '%';
      } else {
        if (textEl) textEl.innerHTML = '<strong>Du har oppnådd gratis frakt! 🎉</strong>';
        if (fillEl) fillEl.style.width = '100%';
        shippingEl.style.display = 'block';
      }
    }

    // empty vs items
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      emptyEl.style.display = 'flex';
      footerEl.style.display = 'none';
      if (shippingEl) shippingEl.style.display = 'none';
      return;
    }

    emptyEl.style.display = 'none';
    footerEl.style.display = 'block';
    subtotalEl.textContent = formatMoney(cart.total_price) + ' KR';

    var html = cart.items.map(function (item, index) {
      var imgHtml = item.image
        ? '<img class="cd-item__img" src="' + escHtml(item.image) + '" alt="' + escHtml(item.title) + '" loading="lazy">'
        : '<div class="cd-item__img-placeholder"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/></svg></div>';

      // variant / meta lines
      var meta = '';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        meta += escHtml(item.variant_title) + '<br>';
      }
      meta += 'Antall: ' + item.quantity;

      return (
        '<div class="cd-item" data-line="' + (index + 1) + '">' +
          imgHtml +
          '<div class="cd-item__body">' +
            '<a href="' + escHtml(item.url) + '" class="cd-item__title">' + escHtml(item.product_title) + '</a>' +
            '<div class="cd-item__meta">' + meta + '</div>' +
            '<div class="cd-qty">' +
              '<button class="cd-qty__btn" data-action="decrease" aria-label="Reduser">−</button>' +
              '<div class="cd-qty__num">' + item.quantity + '</div>' +
              '<button class="cd-qty__btn" data-action="increase" aria-label="Øk">+</button>' +
            '</div>' +
            '<div class="cd-item__price">' + formatMoney(item.line_price) + '</div>' +
          '</div>' +
          '<button class="cd-item__remove" data-line="' + (index + 1) + '" aria-label="Fjern vare">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
              '<path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"/>' +
            '</svg>' +
          '</button>' +
        '</div>'
      );
    }).join('');

    itemsEl.innerHTML = html;
  }

  // ── Update header cart count ───────────────────────────
  function updateHeaderCounts(count) {
    document.querySelectorAll('.cart-count, .cart_count, [data-cart-count], .icon-cart-count, .cart-item-count, [data-item-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  // ── Change quantity ────────────────────────────────────
  function updateLine(line, quantity) {
    showLoading();
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) { renderCart(cart); })
    .finally(function () { hideLoading(); });
  }

  // ── Add to cart ────────────────────────────────────────
  function addToCart(form) {
    showLoading();
    openDrawer();
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: new FormData(form)
    })
    .then(function () { return fetchCart(); })
    .then(function (cart) { renderCart(cart); })
    .catch(function (err) { console.error('Cart error:', err); })
    .finally(function () { hideLoading(); });
  }

  // ── Events ────────────────────────────────────────────
  overlay.addEventListener('click', closeDrawer);
  qs('.cd-close').addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // Qty & remove inside drawer
  itemsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action]');
    var removeBtn = e.target.closest('.cd-item__remove');

    if (btn) {
      var item = btn.closest('.cd-item');
      var line = parseInt(item.dataset.line, 10);
      var current = parseInt(qs('.cd-qty__num', item).textContent, 10);
      var newQty = btn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
      updateLine(line, newQty);
    }

    if (removeBtn) {
      updateLine(parseInt(removeBtn.dataset.line, 10), 0);
    }
  });

  // Intercept add-to-cart form submissions (capture phase — before Turbo)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[action*="/cart/add"], [data-product-form]')) return;
    if (form.closest('#cart-drawer') || document.body.classList.contains('cart')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addToCart(form);
  }, true);

  // Intercept Turbo ajax-submit click
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ajax-submit');
    if (!btn) return;
    var form = btn.closest('form');
    if (!form || form.closest('#cart-drawer') || document.body.classList.contains('cart')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addToCart(form);
  }, true);

  // Cart icon → open drawer (skip links inside the drawer itself)
  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('a[href="/cart"]');
    if (!cartLink) return;
    if (cartLink.closest('#cart-drawer')) return;
    if (document.body.classList.contains('cart')) return;
    e.preventDefault();
    fetchCart().then(function (cart) {
      renderCart(cart);
      openDrawer();
    });
  });

  // Init — populate counts on page load
  fetchCart().then(function (cart) { renderCart(cart); });

  // Global API — dışarıdan çağrılabilsin
  window.CartDrawer = {
    open: function () {
      fetchCart().then(function (cart) {
        renderCart(cart);
        openDrawer();
      });
    },
    close: closeDrawer
  };

})();
